import { IconDefinition } from "./types";

const twitter: IconDefinition = {
  iconName: "twitter",
  width: 16,
  height: 16,
  svgPathData:
    "M15.5673333,4.43333333 L14.1666667,3.83333333 L14.9006667,2.23333333 L13.1933333,2.8 C12.6506667,2.29333333 11.9373333,2.008 11.1933333,2 C9.53866667,2.00333333 8.19733333,3.34466667 8.19333333,5 L8.19333333,5.66666667 C5.83333333,6.15333333 3.774,4.86666667 1.86,2.66666667 C1.52666667,4.44466667 1.86,5.778 2.86,6.66666667 L0.666666667,6.33333333 C0.842,7.79066667 2.03533333,8.914 3.5,9 L1.66666667,9.66666667 C2.33333333,11 3.54733333,11.2066667 5.16666667,11.3333333 C3.84333333,12.2366667 2.27,12.7026667 0.666666667,12.6666667 C9.174,16.4466667 14.1666667,10.8933333 14.1666667,6 L14.1666667,5.44666667 L15.5673333,4.43333333 Z",
  iconType: "fill",
};

export { twitter };
